<template>
		<div class="course-detail">
			<div class="cont">
				<div class="main">
					<div class="back" @click="goBack">< 返回</div>
					<div :class="isScreen?'iframeContAct':'iframeCont'" v-if="query&&query.qf_url">
						<div class="screen" @click="isScreen=!isScreen">{{isScreen?'窗口':'全屏'}}</div>
					  <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="query&&query.qf_url+'&user_id='+userInfo.qfUserId+'&token='+userInfo.qfToken" style="border: none;"></iframe>
					</div>
					<video v-else :src="query&&query.video_url" controls></video>
					<div class="text-cont">
						<div class="title">
							<div>{{query&&query.name}}</div>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="sub-head">
						<div class="course-title">课程列表</div>
					</div>	
					<!-- <div class="course-cont">
						<div class="course-card" @click="checkTi(index)" v-for="(item,index) in courseDetailList" :key="index">
							<div class="course-bg" :style="{backgroundImage:`url(${item.coverImg})`}">
							</div>
							<div class="course-name">{{item.name}}</div>
							<div class="course-text">{{item.point_info}}</div>
							<div class="course-btn">
								<span class="course-teacher">{{item.teacher}}</span>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			query:null,
			isScreen:false,
		}
	},

	created(){
		this.query = this.$route.query;
		console.dir(this.query.qf_url)
	},
	beforeDestroy() {

	},
	mounted() {

	},

	computed: {

	},
	watch: {

	},
	methods: {
		goBack(){
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped>
.course-detail{
	padding: 1.5rem;
	.cont{
		display: flex;
		.main{
			flex:1;
			margin-right: 1.5rem;
			.back{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-size: 1.5rem;
				line-height: 1.88rem;
				margin-bottom: 1.5rem;
			}
			video{
				width: 90%;
			}
			.iframeCont{
				iframe{
					width: 100%;
					height: 43rem;
				}
			}
			.iframeContAct{
				position: absolute;
				z-index: 99;
				width: 100vw;
				height: 100vh;
				top: 0;
				left: 0;
				background-color: #fff;
				iframe{
					width: 100vw;
					height: 100vh;
				}
			}
			.screen{
				text-align: center;
				width: 3rem;
				height: 3rem;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 100%;
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1rem;
				line-height: 1.88rem;
				position: absolute;
				bottom: 4rem;
				left: 2rem;
				z-index: 999;
				color: #FFFFFF;
				background: rgb(100, 45, 113);
				border: 0.2rem solid #E0E0E0;
			}
			.text-cont{
				background-color: #FFF;
				padding: 1.2rem;
				margin-top: 0.2rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-radius: 0.2rem;
			}
			.title{
				font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
				font-weight: 500;
				font-size: 1.6rem;
				color: #000000;
				line-height: 1.7rem;
				display: flex;
				align-items: center;
				.ruo{
					background-color: rgb(100, 45, 113);
					border-radius: 0.25rem;
					padding: 0 1rem;
					color: #fff;
					margin-left: 1.5rem;
					font-size: 1rem;
					font-weight: 400;
				}
			}
			.details{
				display: flex;
				width: 18rem;
				font-size: 1.4rem;
				justify-content: space-between;
			}
		}
		// <div class="cont">
		// 	<div class="main">
		// 		<video src="" controls></video>
		// 		<div class="title">
		// 			<div>平抛运动详解</div>
		// 			<div class="ruo">绝对值</div>
		// 		</div>
		// 		<div class="details">
		// 			<div>初三 - 数学</div>
		// 			<div>老师：李老师</div>
		// 		</div>
		// 	</div>
		// 	<div class="right">
		.right{
			width: 19rem;
			.sub-head{
				margin-bottom: 1.25rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-left: 0.75rem;
				.course-title{
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-weight: 500;
					font-size: 1.6rem;
					color: #000000;
					line-height: 1.7rem;
				}
				.course-more{
					display: flex;
					align-items: center;
					font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
					font-size: 1.2rem;
					color: rgba(0,0,0,0.8);
					line-height: 1.41rem;
					img{
						width: 1.4rem;
						height: 1.4rem;
					}
				}
				.goTest{
					font-size: 1.1rem;
					color: #642d71;
					border: 1px solid #642d71;
					border-radius: 4px;
					padding: 1px 4px;
				}
			}
			.course-cont{
				// display: flex;
				// flex-direction: column;
				// justify-content: flex-start;
				height: 51rem;
				box-sizing: border-box;
				overflow-y: auto;
				overflow-x: hidden;
				.course-card{
					width: 18.35rem;
					height: 14.45rem;
					background: #FFFFFF;
					border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
					margin: 0.7rem;
					overflow: hidden;
					.course-bg{
						width: 18.35rem;
						height: 7.5rem;
						background-repeat: no-repeat;
						background-size: cover;
						position: relative;
						.course-study{
							position: absolute;
							top: 0.75rem;
							left: 0.75rem;
							width: 4.35rem;
							height: 1.8rem;
							background: rgba(141,51,0,1);
							border-radius: 3rem 3rem 3rem 3rem;
							font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
							font-size: 0.8rem;
							color: rgb(100, 45, 113);
							line-height: 1.8rem;
							text-align: center;
						}
						.course-ruo{
								position: absolute;
								right: 0;
								top: 0;
								width: 2.45rem;
								height: 2.05rem;
						}
					}
					.course-name{
						margin: 0.75rem 0.9rem 0.6rem;
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-weight: 500;
						font-size: 1.2rem;
						color: #1D1D1D;
						line-height: 1.3rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						/*! autoprefixer: off */
						-webkit-box-orient: vertical;
					}
					.course-text{
						margin: 0 0.9rem 0.5rem;
						font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
						font-size: 0.8rem;
						color: #74798C;
						line-height: 1rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						/*! autoprefixer: off */
						-webkit-box-orient: vertical;
					}
					.course-btn{
						display: flex;
						align-items: center;
						justify-content: flex-start;
						margin: 0 0.9rem;
						.course-avator{
							width: 1.2rem;
							height: 1.2rem;
							border-radius: 6rem;
							margin-right: 0.4rem;
						}
						.course-teacher{
							font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
							font-size: 0.8rem;
							color: #1D1D1D;
							line-height: 1.12rem;
						}
						.course-save{
							background-image: url('../assets/heart-1.png');
							background-repeat: no-repeat;
							background-size: contain;
							width: 1.2rem;
							height: 1.2rem;
							margin-left: auto;
						}
					}
				}
			}
		}
	}
}
</style>
